<template>
    <div id='steps'>
        <div class="stepsTab">
            <div class="pubw">
                <div class="content">
                    <div class="progressBox">
                        <div class="left">
                        <div class="h">第 1 步</div>
                        <p>報價</p>
                        </div>
                        <div class="right arrow">
                        <span class="el-icon-caret-right"></span>
                        </div>
                    </div>
                    <div class="progressBox" :class="curStep==2?'stepAcitve':''">
                        <div class="left" :class="curStep>2?'canClick':''" @click="changeStep(2)">
                        <div class="h">第 2 步</div>
                        <p>報關</p>
                        </div>
                        <div class="right arrow">
                        <span class="el-icon-caret-right"></span>
                        </div>
                    </div>
                    <div class="progressBox" :class="curStep==3?'stepAcitve':''">
                        <div class="left"  :class="curStep>3?'canClick':''" @click="changeStep(3)">
                        <div class="h">第 3 步</div>
                        <p>地址</p>
                        </div>
                        <div class="right arrow">
                        <span class="el-icon-caret-right"></span>
                        </div>
                    </div>
                    <div class="progressBox" :class="curStep==4?'stepAcitve':''">
                        <div class="left"  :class="curStep>4?'canClick':''" @click="changeStep(4)">
                        <div class="h">第 4 步</div>
                        <p>取件</p>
                        </div>
                        <div class="right arrow">
                        <span class="el-icon-caret-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="curStep">
            <div class="pubw">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
    name:'Steps',
    data(){
        return {
        }
    },
    methods: {
        ...mapMutations(["CHANGESTEP"]),
        // 监听用户点击切换Tip
        changeStep(step){
            console.log(step, 'change')
            // 只允许跳转之前的
            if(step<this.curStep) return
            this.CHANGESTEP(step)
            this.$router.push(`step${step}`)
        }
    },
    created() {
        this.$router.push(`step2`)
        this.CHANGESTEP(2)
    },
    computed:{
        ...mapState({
            curStep:state=>state.curStep
        })
    }
}
</script>

<style lang="less">
#steps{
    .stepsTab{
        background-color: #F2F2F2;
        .content{
                display: flex;
                padding-top: 100px;
                padding-bottom: 30px;
        }
        .progressBox{
        display: flex;
        align-items: center;
        height: 55px;
        margin: 0 5px;
        .left{
          margin-right:10px;
          border-radius:5px;
          padding:0 20px;
          text-align: center;
          .h{
            font-size: 16px;
            color: #868686;
            text-align: center;
            margin-top: 8px;
            margin-bottom: 10px;
          }
          p{
            font-size: 17px;
            font-weight: 550;
            line-height: 20px;
            color: #868686;
          }
        }
        .left.canClick:hover{
            cursor: pointer;
            opacity: .8;
          }
        .right{
          span{
            font-size: 20px;
            color:#868686;
          }
        }
      }
      .progressBox.stepAcitve{
        .left{
            .h{
                font-size: 17px;
                color: #000000;
            }
            p{
                font-size: 18px;
                color: #000000;
            }
        }
    }
    .progressBox:last-child .right span{
        opacity: 0;
      }
    }
    .curStep{
        padding-bottom: 80px;
        background-color: #fff;
    }
}
</style>